import { useMutation, useQueryClient } from "react-query";
import { useContext } from "react";
import { AuthContext } from "../../Context/AuthContext";

const useSignVesselNominationAgreement = () => {
  const { token } = useContext(AuthContext);
  const queryClient = useQueryClient();

  const signAgreement = async ({ requestId, body }) => {
    if (!token) throw new Error("Token is missing");
    if (!requestId) throw new Error("Request ID is required");
    
    const response = await fetch(
      `${process.env.REACT_APP_SERVER_URL}/charter/charterer/signVesselNominationAgreement/${requestId}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      }
    );

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Failed to sign vessel nomination agreement");
    }

    return data;
  };

  const {
    mutate,
    isLoading,
    isSuccess,
    isError,
    error,
    data,
  } = useMutation(signAgreement, {
    onSuccess: () => {
      // Invalidate and refetch charter requests to get updated data
      queryClient.invalidateQueries(["readAllCharterRequests"]);
      queryClient.invalidateQueries(["readCharterRequest"]);
    },
  });

  return {
    signAgreement: mutate,
    isLoading,
    isSuccess,
    isError,
    error,
    data,
  };
};

export default useSignVesselNominationAgreement; 